import { Button, Drawer, Grid, Form } from "antd";
import CreateCustomerForm from "./CreateCustomerForm";

const CustomerDrawer = ({ open, onClose, authInfo, onCreated }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [form] = Form.useForm(); // ✅ shared form instance

  return (
    <Drawer
      open={open}
      width={screens.md ? 720 : "100%"}
      title="Create Customer"
      onClose={onClose}
      destroyOnHidden={true}
      styles={{
        body: { paddingInline: screens.md ? 40 : 20 , paddingBottom: 88},
        wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          } 
      }}
        
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
          }}
        >
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      }
    >
      <CreateCustomerForm
        form={form}          
        authInfo={authInfo}
        isDrawer
        onSuccess={(createdCustomer) => {
          onCreated(createdCustomer);
          onClose();
        }}
      />
    </Drawer>
  );
};

export default CustomerDrawer;
